import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import orderBy from 'lodash/orderBy'
import ReactList from 'react-list'
import { GoTriangleDown, GoTriangleUp } from 'react-icons/go'

import { SaleProductItem } from './sale-product-item'

import { saleProductSelector } from '../../../selectors'

import { FONTS } from '../../../constants'

const filterSaleProduct = (list, lobList, keywordSearch) => {
  const keyword = keywordSearch.toLowerCase()
  if (keyword === '') return list
  return list.filter(l => {
    const lob = lobList.find(lob => l.lob_id === lob.value)
    return l.product_code.toLowerCase().indexOf(keyword) > -1
    || l.name.toLowerCase().indexOf(keyword) > -1
    || (lob && lob.label.toLowerCase().indexOf(keyword) > -1)
  })
}

export const DataTable = React.memo(({
  saleProductList,
  activeItem,
  lobList,
  handleClickRow,
}) => {
  const sortColumn = [
    value => parseInt(value.product_code, 10),
    'name',
    value => {
      const lob = lobList.find(l => l.value === value.lob_id)
      return lob.label
    },
    'start_date',
    'end_date',
  ]

  const [sortOrder, setSortOrder] = useState({ col: 0, desc: false })
  const keywordSearch = useSelector(saleProductSelector.getKeywordSearch)
  const productList = orderBy(
    filterSaleProduct(
      saleProductList,
      lobList,
      keywordSearch
    ),
    sortColumn[sortOrder.col], sortOrder.desc ? 'desc' : 'asc'
  )

  const renderIcon = (col) => {
    if (sortOrder.col === col) {
      return sortOrder.desc ? <GoTriangleDown /> : <GoTriangleUp />
    }
    return null
  }

  const handleSort = (col) => {
    if (sortOrder.col === col) {
      setSortOrder({ ...sortOrder, desc: !sortOrder.desc })
    } else {
      setSortOrder({ col, desc: true })
    }
  }

  const renderItem = (index) => {
    const item = productList[index]

    return (
      <SaleProductItem
        key={ item._id }
        item={ item }
        activeItem={ activeItem }
        lobList={ lobList }
        handleClickRow={ handleClickRow }
      />
    )
  }

  return (
    <Root>
      <HeaderRow>
        <CodeCol onClick={ () => handleSort(0) }>
          Code
          {renderIcon(0)}
        </CodeCol>
        <NameCol onClick={ () => handleSort(1) }>
          Name
          {renderIcon(1)}
        </NameCol>
        <LOBCol onClick={ () => handleSort(2) }>
          LOB
          {renderIcon(2)}
        </LOBCol>
        <StateDateCol onClick={ () => handleSort(3) }>
          Start Date
          {renderIcon(3)}
        </StateDateCol>
        <EndDateCol onClick={ () => handleSort(4) }>
          End Date
          {renderIcon(4)}
        </EndDateCol>
      </HeaderRow>
      <RowWrapper>
        <ReactList
          itemRenderer={ renderItem }
          length={ productList.length }
        />
      </RowWrapper>
    </Root>
  )
})

const Root = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const RowWrapper = styled.div`
  max-height: calc(100vh - 190px);
  overflow-y: scroll;
`

const Row = styled.div`
    height: 35px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    background: #FFFFFF;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #1A1A17;
    border-top: 1px solid #EAEAEA;
    cursor: pointer;

    :nth-child(1) {
        border: none;
    }

    :hover {
      background-color: rgba(0, 0, 0, 0.075);
    }
`

const HeaderRow = styled(Row)`
    background: #4F4F4F;
    font-family: ${FONTS.GOTHAM_BOLD};
    font-size: ${FONTS.SMALL_SIZE};
    color: #FFFFFF;

    :hover {
      background: #4F4F4F;
    }
`

const CodeCol = styled.div`
    flex: 2;

    svg {
      margin-left: 8px;
      font-size: 16px;
    }
`

const NameCol = styled(CodeCol)`
    flex: 3;
`

const LOBCol = styled(CodeCol)`
    flex: 3;
`

const StateDateCol = styled(CodeCol)`
    flex: 2;
`

const EndDateCol = styled(CodeCol)`
    flex: 2;
`



// WEBPACK FOOTER //
// ./src/components/sale-product/data-table/index.js